export const ENDPOINT = {
    AUTH: {
        LOGIN:'auth/login',
        REGISTER:'auth/register',
        CREATEOTP:'auth/generateOtp',
        VERIFYOTP:'auth/verifyOtp',
        FORGETPASSWORD:'auth/forgot-password',
        CHANGEPASSWORD:'auth/change-password',
        VERIFY2FA:'twofactor/verify-login'
    },
    USER: {
        GET:'user/get',
        VERIFY: 'user/verified',
        BLOCK: 'user/block',
        GETBLOCKED: 'user/getBlocked',
        GETARCHIVED: 'user/getArchived',
        ARCHIVE: 'user/archive',
        UPDATEROLE:'user/role',
        SEARCH:'user/search'
    },
    PRICE: {
        UPLOADRANGES:'price/range/bulk',
        GETRANGES:'price/range',
        UPLOADSTAGES:'price/stage/bulk',
        GETSTAGES:'price/stage',
        UPLOADMULTIPLIER:'price/multiplier/bulk',
        GETMULTIPLIER:'price/multiplier',
        UPLOADCHARGE:'price/charge/bulk',
        GETCHARGE:'price/charge',
    },
    PROFILE: {
        GET: 'user/getUser',
        UPDATEUSER: 'user/update'
    },
    SERVICE: {
        INSERT:'services/insert',
        UPDATE:'services/update',
        GET:'services/getUnOrderedServices',
        DELETE:'services/delete',
        CHANGESTAGE:'services/changeStage',
        UPDATEPRICE: 'services/updatePrice'
    },
    PRIMER: {
        SEARCH:'primers/search',
        GET:'primers/get-primers',
        GETCUSTOM:'primers/get-custom-primers',
        GETALL:'primers/all',
        INSERT:'primers/create',
        GETBYID:'primers/get-primer',
        UPDATE:'primers/update',
        DELETE:'primers/delete',
        VERIFY:'primers/verify',
        ARCHIVE:'primers/archive',
        SEARCHPRIMER: 'primers/searchPrimer',
        FILTEROPTIONS: 'primers/filter-options'
    },
    CHECKOUT: {
        GETCONTACTS: 'checkout/contacts',
        GENERATEOFFER: 'checkout/generateOffer',
        GETPDF: 'checkout/getPdf',
        CREATESIGNATURE: 'signature/createSignature',
        GETSIGNATURE: 'signature/getSignature',
        SIGNOFFER: 'signature/signOffer',
        SENDMAIL: 'signature/sendEmail',
        CREATEFRAMEWORK: 'framework/create',
        GETRECOMMENDEDUSERS: 'framework/recommended',
        SEARCHUSERS: 'framework/search',
        CHECKDISCOUNT: 'discounts/checkIfDiscountIsUsed',
        GETWALLETBALANCE: 'wallet/getWalletBalance',
        GETCUSTOMER: 'checkout/searchCustomer',
        GETCUSTOMERCONTACTS: 'checkout/getCustomerContact',
        GETEINVOICEINFO: 'checkout/eInvoiceInfo'
    },
    SIGNOFFER: {
        VALIDATETOKEN: 'signature/validateToken',
        SIGN: 'signature/signOfferWithContact',
        GETPDF: 'signature/getPdf'
    },
    CONTRACT: {
        GETALL: 'framework/getAll',
        GET: 'framework/get',
        GETFORUPDATE: 'framework/getForUpdate',
        UPDATE: 'framework/update',
        CREATEBATCHES: 'framework/createBatches',
        GETREQUESTCOUNT: 'framework/getRequest',
        BATCHACTIONREQUEST: 'framework/batchRequestAction',
        CHANGEADMINROLE: 'framework/changeFrameworkContractAdmin',
        SYNCPRIMERLAND: 'framework/sync-primerland'
    },
    WALLET: {
        ADD: 'wallet/addWallet',
        UPDATE: 'wallet/updateWallet',
        GET: 'wallet/getWallet',
        GETBYID: 'wallet/getWalletById',
        DELETE: 'wallet/deleteWallet'
    },
    DISCOUNT:{
        GET: 'discounts/get',
        CREATE: 'discounts/create',
        UPDATE: 'discounts/update',
        DELETE: 'discounts/delete',
        GET_USERS: 'discounts/getUsers',
        SEARCH: 'discounts/search',
        GETBYUSERID: 'discounts/getForUser'
    },
    PROJECT: {
        GETSAMPLES: 'labordata/get-recent-batch',
        GETSAMPLESBYBATCHID: 'labordata/get-sample-by-batch',
        CHANGESAMPLENAMES: 'labordata/change-sample-name',
        GETPROJECTS: 'project/get-projects',
        GETALLPROJECTS: 'project/get-all-projects',
        SEARCHPROJECTS: 'project/search-projects',
        GETLABELS: 'labordata/get-sample-from-lab',
        GETPROJECTBYID: 'project/get-project-by-id',
        ADDBATCH: 'project/create-batches',
        GETBATCHSAMPLE: 'labordata/get-samples-for-batch',
        ADDRESULT: 'project/results',
        OFFER: 'project/offer-download',
        INVOICE: 'project/invoice-download',
        GETBATCH: 'project/get-batch-by-id',
        GETINVOICEINFO: 'project/get-invoice-info',
        CORRECTINVOICE: 'project/invoice-correction',
        CANCELINVOICE: 'project/cancel-invoice',
        SENDSIGNINGEMAIL: 'signature/sendEmail',
        CANCELPROJECT: 'project/cancel-project',
        GETEINVOICE: 'project/invoice-download-xrechnung',
        UPLOADSIGNEDOFFER: 'signature/uploadSignedOffer',
        EDITPROJECT: 'project/edit-project',
        GETCONTACTBYID: 'project/get-contact',
        UPDATESAMPLEFIELD: 'project/update-sample',
        UPDATEINVOICE: 'project/update-invoice-info',
        SYNCPRIMERLAND: 'project/sync-primerland'
    },
    DASHBOARD: {
        GETTASKS: 'dashboard',
        ADDPROMOTIONS: 'dashboard/add-promotion',
        EDITPROMOTIONS: 'dashboard/edit-promotion',
        DELETEPROMOTIONS: 'dashboard/delete-promotion',
        GETPROMOTIONS: 'dashboard/promotions',
        GETPROMOTIONBYID: 'dashboard/promotion',
        TOUR: 'dashboard/tour',
        ENABLE2FA: 'twofactor/enable',
        START2FASETUP: 'twofactor/setup'
    },
    SIDEBAR: {
        GETUNVERIFIEDPRIMER: 'primers/get-unverified-primers',
        GETUNVERIFIEDCUSTOMER: 'user/get-unverified-users'
    },
    INVOICES: {
        GET: 'invoice/get-invoices',
        SEARCH: 'invoice/search-invoice',
        SEARCHBYPLATEFORM: 'invoice/search-by-plateform',
        SEARCHBYSTATUS: 'invoice/search-by-status'
    }
};